import { render, staticRenderFns } from "./MediaCall.vue?vue&type=template&id=09801102"
import script from "./MediaCall.vue?vue&type=script&lang=js"
export * from "./MediaCall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports